var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResponsiveLayout',{attrs:{"mobileComponent":_vm.CertificateMobile,"desktopComponent":_vm.Certificate}})}
var staticRenderFns = []

export { render, staticRenderFns }